import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const BAT = { player: "", how_out: "", runs: 0, balls: 0, fours: 0, sixes: 0 };
const BOWL = { player: "", overs: 0, maidens: 0, runs: 0, wickets: 0 };
const cell = "h-9 rounded-sm border-white/15 bg-[#0A192F] px-2 text-sm";

const Rows = ({ rows, cols, blank, onChange, testid }) => (
  <div className="overflow-x-auto">
    <table className="w-full min-w-[560px] text-xs">
      <thead className="text-left uppercase tracking-wider text-slate-500"><tr>{cols.map(([k, l]) => <th key={k} className="px-1 py-2">{l}</th>)}<th /></tr></thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            {cols.map(([k, , num]) => (
              <td key={k} className="px-1 py-1">
                <Input className={`${cell} ${num ? "w-16" : ""}`} type={num ? "number" : "text"} step="any" value={r[k]}
                  onChange={(e) => onChange(rows.map((x, j) => (j === i ? { ...x, [k]: num ? Number(e.target.value || 0) : e.target.value } : x)))} />
              </td>
            ))}
            <td><button type="button" aria-label="Remove row" onClick={() => onChange(rows.filter((_, j) => j !== i))} className="p-2 text-slate-500 hover:text-red-300"><Trash2 className="h-4 w-4" /></button></td>
          </tr>
        ))}
      </tbody>
    </table>
    <button type="button" data-testid={testid} onClick={() => onChange([...rows, { ...blank }])} className="mt-2 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-[#00E5FF]"><Plus className="h-3.5 w-3.5" />Add row</button>
  </div>
);

export default function ScorecardEditor({ match, teams, onChange }) {
  const innings = match.innings || [];
  const setInn = (i, patch) => onChange({ ...match, innings: innings.map((x, j) => (j === i ? { ...x, ...patch } : x)) });
  const opts = [match.team_a_id, match.team_b_id].filter(Boolean).map((id) => teams.find((t) => t.id === id)).filter(Boolean);
  return (
    <div data-testid="scorecard-editor" className="space-y-6">
      {innings.map((inn, i) => (
        <div key={i} className="space-y-4 rounded-md border border-white/10 bg-[#0A192F]/60 p-4">
          <div className="flex flex-wrap items-end gap-3">
            <div className="min-w-[180px] flex-1">
              <p className="mb-1 text-xs uppercase tracking-wider text-slate-400">Innings {i + 1} · batting team</p>
              <Select value={inn.team_id || undefined} onValueChange={(v) => setInn(i, { team_id: v })}>
                <SelectTrigger className="rounded-sm border-white/15 bg-[#0A192F]"><SelectValue placeholder="Select team" /></SelectTrigger>
                <SelectContent className="border-white/15 bg-[#112240] text-white">{opts.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            {[["runs", "Runs"], ["wickets", "Wkts"], ["overs", "Overs"], ["extras", "Extras"]].map(([k, l]) => (
              <div key={k}><p className="mb-1 text-xs uppercase tracking-wider text-slate-400">{l}</p>
                <Input type="number" step="any" className={`${cell} w-20`} value={inn[k]} onChange={(e) => setInn(i, { [k]: Number(e.target.value || 0) })} /></div>
            ))}
            <button type="button" onClick={() => onChange({ ...match, innings: innings.filter((_, j) => j !== i) })} className="text-xs text-red-300">Remove innings</button>
          </div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-300">Batting</p>
          <Rows testid={`add-bat-row-${i}`} rows={inn.batting || []} blank={BAT} onChange={(r) => setInn(i, { batting: r })} cols={[["player", "Batter"], ["how_out", "Dismissal"], ["runs", "R", 1], ["balls", "B", 1], ["fours", "4s", 1], ["sixes", "6s", 1]]} />
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-300">Bowling</p>
          <Rows testid={`add-bowl-row-${i}`} rows={inn.bowling || []} blank={BOWL} onChange={(r) => setInn(i, { bowling: r })} cols={[["player", "Bowler"], ["overs", "O", 1], ["maidens", "M", 1], ["runs", "R", 1], ["wickets", "W", 1]]} />
        </div>
      ))}
      {innings.length < 2 && (
        <button type="button" data-testid="add-innings-btn" onClick={() => onChange({ ...match, innings: [...innings, { team_id: "", runs: 0, wickets: 0, overs: 0, extras: 0, batting: [], bowling: [] }] })}
          className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-xs font-bold uppercase tracking-wider hover:border-[#00E5FF]"><Plus className="h-4 w-4" />Add innings</button>
      )}
    </div>
  );
}
